module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/phone-bg.e430a035.jpg";